export default "__VITE_ASSET__CpeqWycp__"